module.exports = __webpack_public_path__ + "img/guang.ee2ada4d.png";